import React from "react";

function MaskIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="45"
      fill="none"
      viewBox="0 0 45 45"
    >
      <path
        fill="#F0B595"
        d="M35.42 13.38c1.336.137 3.34.643 4.86 1.235 1.064.412 3.182 1.442 3.727 1.81.518.344.879.85.958 1.339.132.875-.66 3.423-1.758 5.637-1.802 3.63-3.516 5.963-5.089 6.94-1.292.807-2.874 1.245-4.72 1.314-1.511.051-1.722 0-3.55-.893-1.275-.617-2.567-1.484-3.525-2.35-1.336-1.202-2.716-2.154-3.498-2.394-.264-.078-.404-.078-.756.043-.597.188-1.837 1.012-2.777 1.836-1.441 1.27-2.795 2.205-4.096 2.84-1.872.918-2.074.97-3.594.918-1.398-.052-2.479-.275-3.604-.738C5.766 29.99 4 27.845 1.793 23.4.694 21.187-.097 18.639.035 17.764c.08-.49.44-.995.958-1.338.545-.37 2.663-1.399 3.727-1.81 2.162-.842 3.92-1.21 6.047-1.27 2.39-.078 3.656.12 8.648 1.303 1.477.352 2.874.644 3.085.644.211 0 1.608-.292 3.085-.643 3.076-.73 4.957-1.116 6.1-1.245.738-.077 3.05-.094 3.735-.025zm-3.023 6.168c-.827.207-1.846.781-2.584 1.45-.712.644-1.574 1.708-1.916 2.377l-.22.42.474.198c1.24.54 2.523.772 3.912.72 1.186-.05 1.828-.223 2.76-.763.667-.377 1.792-1.416 2.328-2.136.343-.464.906-1.382.906-1.485 0-.077-1.292-.54-1.96-.703-1.345-.318-2.628-.352-3.7-.078zm-22.28-.137c-.361.052-.915.146-1.231.223-.66.155-1.943.618-1.943.695 0 .035.123.266.273.532.984 1.7 2.566 3.089 4.122 3.63.5.171.738.197 1.934.197 1.045 0 1.502-.043 1.977-.163.738-.189 1.96-.635 2.021-.738.132-.206-1.116-1.896-2.012-2.728-1.468-1.356-3.155-1.896-5.142-1.648z"
      ></path>
    </svg>
  );
}

export default MaskIcon;
